<!-- **
  * 显示样式参考 空调系统界面
  * rateFlag:false
  *  value unit
  *    name
  * rateFlag:true
  *  value/valuetotal
  *   name/nametotal
* -->
<template>
    <div v-if="listData.length > 0" :class="classObject">
        <div :style="{ width: listData.length === 1 ? '100%' : '' }" v-for="(v, i) in listData" :key="i">
            <div class="firstDiv">
                <div v-if="v.rateFlag">
                    <span :title=v.value class="highlight">{{ dealBigNum(v.value) }}</span>
                    <span :title=v.valueTotal class="bold">/{{ dealBigNum(v.valueTotal) }}</span>
                    <!-- {{ `${v.value}/${v.valueTotal}` }} -->
                </div>
                <div v-else>
                    <span :title=v.value class="highlight">{{ dealBigNum(v.value) }}</span>
                    <span v-if="!!v.unit && !combineNameUnit">{{ v.unit }}</span>
                </div>
            </div>
            <div class="secondDiv">
                <div v-if="v.rateFlag">
                    <span>{{ `${v.name}/${v.nameTotal}` }}</span>
                </div>
                <div v-else>
                    <span v-if="combineNameUnit">{{ `${v.name}${!!v?.unit ? `(${v.unit})` : ""}` }}</span>
                    <span v-else>{{ v.name }}</span>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
const classNames = require('classnames')
import { dealBigNum } from "@/assets/js/utils";
export default {
    name: "HeadTips",
    props: {
        listData: {
            type: Array,
            default: () => []
        },
        twoLine: {
            type: Boolean,
            default: false,
        },
        className: {
            type: String,
            default: ""
        },
        combineNameUnit: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            listColor: [
                "#279fff",
                "#29c444",
                "#fecc2b",
                "#7472fc",
                "#279fff",
                "#29c444",
                "#fecc2b",
            ],
            value: false,
        };
    },
    computed: {
        classObject: function () {
            return classNames({
                'headTips': true,
                'twoLine': this.twoLine,
                [this.className]: !!this.className,
            })
        }
    },
    methods: {
        dealBigNum
    },
};
</script>
  
<style lang="scss" scoped>
.headTips {
    width: 100%;
    height: 100%;
    @include setFlexBetween;

    &>div {
        @include setFlexColumn;
        width: 155px;
        height: 100%;
        align-items: center;
        justify-content: center;

        .firstDiv {
            font-size: 14px;
            min-height: 30px;

            .highlight {
                color: #28CCCB;
                font-weight: bold;
                font-size: 30px;
            }

            .bold {
                color: black;
                font-weight: bold;
                font-size: 26px;
            }
        }

        .secondDiv {
            margin-top: 10px;
        }
    }
}

.twoLine {
    flex-wrap: wrap;

    &>div {
        width: 80px;
        height: 50%;

        .firstDiv {
            font-size: 14px;
            min-height: 30px;

            .highlight {
                color: #28CCCB;
                font-weight: bold;
                font-size: 26px;
            }

            .bold {
                color: black;
                font-weight: bold;
                font-size: 22px;
            }
        }

        .secondDiv {}
    }
}
</style>